import React from "react";

const NewsCategoryPageContext = React.createContext();

export { NewsCategoryPageContext };
